var render = function render(){var _vm=this,_c=_vm._self._c;return _c('flat-pickr',{staticClass:"form-control rounded-none",attrs:{"config":_vm.flatpickr_config,"placeholder":"Choose Date","name":"date"},model:{value:(_vm.dummy_value),callback:function ($$v) {_vm.dummy_value=$$v},expression:"dummy_value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }